import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { Ratecap, RatecapItems, requestforEmulationPayload } from '../../shared/models/model';
import { WidgetsService } from '../../shared/services/widgets.service';
import { CommonModule } from '@angular/common';
import { FooterService } from '../../shared/services/footer.service';
import { Subscription } from 'rxjs';
import { EmulationService } from '../../shared/services/emulation.service';

@Component({
  selector: 'app-latest-rates',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './latest-rates.component.html',
  styleUrl: './latest-rates.component.scss',
})
export class LatestRatesComponent implements OnInit, OnDestroy {
  ratecapInfos: RatecapItems[] = [];
  errorMessage: string = '';
  complianceId: string = '';
  fetchRateCapssubscription: Subscription = new Subscription();
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  constructor(
    private _widgetService: WidgetsService,
    private _footerService: FooterService,
    private _emulationService: EmulationService,
  ) {}

  ngOnInit(): void {
    this.getRatecapInfo();
  }
  getRatecapInfo(): void {
    // payload for fetching promos
    const payLoad: requestforEmulationPayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    this.fetchRateCapssubscription = this._widgetService.fetchRateCaps(payLoad).subscribe({
      next: (data: Ratecap) => {
        if (data && data.rateCapList) {
          this.ratecapInfos = data.rateCapList;
          this._footerService.setComplianceID(data.complianceId);
          this.complianceId = this._footerService.getComplianceId();
        }
      },
      error: (error: string) => {
        this.errorMessage = error;
      },
    });
  }
  ngOnDestroy(): void {
    // Unsubscribe from all
    this.fetchRateCapssubscription.unsubscribe();
  }
}
